<div
  class="spot-modal-overlay"
  [class.spot-modal-overlay_active]="(activeModalInstance$ | async) !== null"
  [class.spot-modal-overlay_not-full-screen]="notFullscreen"
  [class.spot-modal-overlay_top]="mobileTopPosition"
  #overlay
  tabindex="0"
  cdkFocusInitial
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (mousedown)="close($event, false)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="spotModalTitle"
  >
  @if ((activeModalInstance$ | async)?.showCloseButton !== false) {
    <button
      type="button"
      class="spot-button spot-modal-overlay--close-button"
      (click)="close($event)"
      >
      <svg x-icon size="small" />
    </button>
  }
  <ng-template cdkPortalOutlet />
</div>
